var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 68.917 19.901",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 234.82,
    x2: 144.8,
    y1: 221.2,
    y2: 377.11,
    gradientTransform: "matrix(.11056 0 0 .11056 -11.035 -23.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a094",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015670",
    offset: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 9.9503,
    cy: 9.9503,
    r: 9.9503,
    fill: "url(#linear-gradient)",
    strokeWidth: 0.11056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.4158 9.402a30.456 30.456 0 0 0 4.2875-4.9907l0.39249-0.59592 0.14483 0.69874c0.4157 1.9989 1.8463 7.4075 3.4627 8.4091a0.2963 0.2963 0 0 1-0.30957 0.50304c-0.92428-0.5738-1.8331-2.2377-2.7032-4.9453-0.40686-1.2637-0.7109-2.4732-0.87895-3.1874-0.63572 0.88448-2.0531 2.5959-3.7723 4.3295a2.2819 2.2819 0 0 0-0.30736 0.3759c-0.53953 0.85352 0.028747 1.2162 0.28082 1.3687 0.86789 0.51852 3.1443-0.76618 3.8176-1.1343l0.77392-0.42234-0.35711 0.80156c-0.04754 0.11056-1.1841 2.6225-3.1775 3.6042a2.2963 2.2963 0 0 1-1.0205 0.2377 2.3582 2.3582 0 0 1-0.66336-0.095081 2.3837 2.3837 0 0 1-1.3168-0.95523c-0.57159-0.85573-0.62024-2.262 0.95855-3.6485 0.13157-0.11609 0.26534-0.2366 0.3947-0.3549",
    strokeWidth: 0.11056
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.586 12.878-0.88447-1.7048h-4.3859l-0.88448 1.7048h-0.64014l3.3765-6.4534h0.68989l3.3776 6.4534zm-3.0769-5.8851-1.906 3.6485h3.8088z",
    strokeWidth: 0.11056
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m34.419 12.878v-6.4534h0.58707v6.4534z",
    strokeWidth: 0.11056
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46.15 9.6463a4.2665 4.2665 0 0 1-0.12936 1.1056 2.8845 2.8845 0 0 1-0.36374 0.83804 2.3693 2.3693 0 0 1-0.57159 0.60587 2.9442 2.9442 0 0 1-0.74628 0.39912 4.3538 4.3538 0 0 1-0.89221 0.22112 7.0758 7.0758 0 0 1-1.0127 0.06855h-3.33v-6.46h3.3168a6.6789 6.6789 0 0 1 1.4749 0.15478 3.1056 3.1056 0 0 1 1.1808 0.52847 2.5274 2.5274 0 0 1 0.78497 0.99503 3.7104 3.7104 0 0 1 0.28856 1.5434zm-0.60144 0a3.7314 3.7314 0 0 0-0.10393-0.93091 2.3361 2.3361 0 0 0-0.2963-0.70316 1.8486 1.8486 0 0 0-0.46988-0.50083 2.4434 2.4434 0 0 0-0.62466-0.32615 3.6341 3.6341 0 0 0-0.75733-0.1769 6.9553 6.9553 0 0 0-0.869-0.051966h-2.7363v5.3865h2.7363a5.9636 5.9636 0 0 0 1.2648-0.12493 2.5009 2.5009 0 0 0 0.98508-0.43229 2.0365 2.0365 0 0 0 0.64124-0.82698 3.2394 3.2394 0 0 0 0.22996-1.309z",
    strokeWidth: 0.11056
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m49.783 12.878v-6.4534h0.58707v6.4534z",
    strokeWidth: 0.11056
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m55.055 6.9741v2.2222h4.2919v0.53511h-4.2919v3.1465h-0.58707v-6.4534h5.1101v0.5528z",
    strokeWidth: 0.11056
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m65.888 10.145v2.733h-0.58707v-2.733l-3.0293-3.7203h0.69984l2.6258 3.2317 2.6158-3.2317h0.70426z",
    strokeWidth: 0.11056
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidifyLogo);
export default __webpack_public_path__ + "static/media/aidify-logo.56f5c9be060f98b405d1b6b4c92c06ee.svg";
export { ForwardRef as ReactComponent };